import { render, staticRenderFns } from "./SenderInformation.vue?vue&type=template&id=2c93a840&scoped=true&"
import script from "./SenderInformation.vue?vue&type=script&lang=js&"
export * from "./SenderInformation.vue?vue&type=script&lang=js&"
import style0 from "./SenderInformation.vue?vue&type=style&index=0&id=2c93a840&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c93a840",
  null
  
)

export default component.exports